export async function syncAuthWithBackend() {
    try {
        const authData = {
            token: localStorage.getItem('access_token'),
            user: localStorage.getItem('userId'),
            userRole: localStorage.getItem('userRole'),
        };
        const result = await window.pywebview.api.sync_auth_from_frontend(authData);
        console.log(result)
        if (result.success) {
            console.log('Auth state synced with notification service');
        } else {
            console.error('Failed to sync auth state:', result.error);
        }
        return result;
    } catch (error) {
        console.error('Error syncing auth state:', error);
        return { success: false, error: error.message };
    }
}

export async function handleLogout() {
    try {
        const result = await window.pywebview.api.logout_user();

        if (result.success) {
            console.log('Logged out successfully');
        } else {
            console.error('Logout error:', result.error);
        }

    } catch (error) {
        console.error('Logout handling error:', error);
    }
}

export async function checkAuthOnStartup() {
    try {
        const hasLocalAuth = localStorage.getItem('access_token');

        if (hasLocalAuth) {
            await syncAuthWithBackend();
        }

        const authStatus = await window.pywebview.api.get_current_auth_status();

        if (authStatus.success && authStatus.authenticated) {
            // console.log('User is authenticated:', authStatus.user_data);
        } else {
            console.log('User is not authenticated');
        }

    } catch (error) {
        console.error('Startup auth check error:', error);
    }
}
